import { useClerk } from "@clerk/react";
import { isClerkAPIResponseError } from "@clerk/react/errors";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { routes } from "@/routes";

export function GoogleAuthButton() {
  const clerk = useClerk();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  async function connect() {
    if (!clerk.client || loading)
      return;
    setLoading(true);
    setError(undefined);
    try {
      await clerk.client.signIn.authenticateWithRedirect({
        strategy: "oauth_google",
        redirectUrl: routes.oauthCallback,
        redirectUrlComplete: routes.profile,
      });
    }
    catch (cause) {
      setError(isClerkAPIResponseError(cause) ? cause.errors[0]?.longMessage ?? cause.errors[0]?.message ?? t("auth.google-error") : t("auth.google-error"));
    }
    finally {
      setLoading(false);
    }
  }

  return (
    <div className="mt-4 space-y-3">
      <Button className="w-full border-neutral-300 bg-white text-neutral-900" disabled={loading || !clerk.loaded} loading={loading} onClick={connect} type="button" variant="outline">
        {t("auth.google")}
      </Button>
      {error && <p className="text-red-300 max-w-sm text-center text-sm" role="alert">{error}</p>}
    </div>
  );
}
